module.exports = __webpack_public_path__ + "static/media/fly0238.72a30d4b.webp";